import React from 'react';

import { BreadcrumbItemType, BreadcrumbSeparatorType } from 'antd/es/breadcrumb/Breadcrumb';

import {
	communityList,
	communityTitle,
	healText,
	movingText,
	movingTitle,
	resourcesList,
	resourcesTitle,
} from '@app/components/Pages/PetLossBeginningToHeal/PetLossBeginningToHealContent';
import CardLinks from '@app/components/UI/CardLinks/CardLinks';
import HelmetProvider from '@app/providers/HelmetProvider/HelmetProvider';
import Masthead from '@app/components/UI/MastHead/Masthead';
import RichText from '@app/components/UI/RichText/RichText';
import petLossHealHeader from '@app/images/content/petLossHealHeader.jpg';

const PetLossBeginningToHeal = () => {
	const [breadcrumbs, setBreadcrumbs] = React.useState<Array<Partial<BreadcrumbItemType & BreadcrumbSeparatorType>> | undefined>();

	React.useEffect(() => {
		const bc: Array<Partial<BreadcrumbItemType & BreadcrumbSeparatorType>> | undefined = [
			{
				path: '/pet-loss-support-resources',
				title: 'Pet Loss Support Resources',
			},
			{
				path: '',
				title: 'Healing Process',
			},
		];

		setBreadcrumbs(bc);
	}, []);

	return (
		<HelmetProvider>
			<div className="pet-loss-heal">
				<Masthead
					title="Beginning to Heal"
					imageSrc={petLossHealHeader}
					breadcrumbs={breadcrumbs}
					backPath={{
						path: '/pet-loss-support-resources',
						name: 'Back to pet loss support resources',
					}}
					imageAlt="Grieving pet loss"
				/>

				<RichText text={healText} />

				<RichText text={resourcesTitle} />

				<CardLinks list={resourcesList} />

				<RichText title={movingTitle} text={movingText} />

				<RichText text={communityTitle} />

				<CardLinks list={communityList} />
			</div>
		</HelmetProvider>
	);
};

export default PetLossBeginningToHeal;
